<script>
  import { onMount } from "svelte";
  import { Card } from "@svelteuidev/core";
  export let saida;
  let selectedDates = [];
  let showCalendar = false;
  let showModal = false;
  let currentMonth = new Date().getMonth();
  let currentYear = new Date().getFullYear();
  let classeSelecao = {};
  const daysOfWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

  function toggleDate(date) {
    const formattedDate = formatDate(date);
    if (selectedDates.includes(formattedDate)) {
      selectedDates = selectedDates.filter((d) => d !== formattedDate);
    } else {
      selectedDates = [...selectedDates, formattedDate];
    }
  }

  function formatDate(date) {
    if (date instanceof Date) {
      return date.toISOString().split("T")[0];
    }
    return date;
  }

  function handleDateSelection() {
    saida = selectedDates;
    closeModal();
  }

  function clearSelection() {
    selectedDates = [];
    saida = "";
    classeSelecao = {};
  }

  function isDateSelected(date) {
    const formattedDate = formatDate(date);
    if (selectedDates.includes(formattedDate)) {
      classeSelecao[formattedDate] = "day selected";
    } else {
      classeSelecao[formattedDate] = "day";
    }
  }

  function getDaysInMonth(year, month) {
    const dates = [];
    const date = new Date(year, month, 1);
    const firstDay = date.getDay();

    // Add blank days for the first week
    for (let i = 0; i < firstDay; i++) {
      dates.push(null);
    }

    while (date.getMonth() === month) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    return dates;
  }

  function changeMonth(direction) {
    if (direction === "prev") {
      currentMonth--;
      if (currentMonth < 0) {
        currentMonth = 11;
        currentYear--;
      }
    } else if (direction === "next") {
      currentMonth++;
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
    }
    dates = getDaysInMonth(currentYear, currentMonth);
  }

  function removeDate(date) {
    const formattedDate = formatDate(date);
    selectedDates = selectedDates.filter((d) => d !== formattedDate);
    isDateSelected(date);
  }

  let dates = [];
  function closeModal() {
    showModal = false;
  }

  onMount(() => {
    dates = getDaysInMonth(currentYear, currentMonth);
  });

 function formatDateToBrazilian(dateStr) {
  // Verifica se a entrada é uma string
  if (typeof dateStr !== "string") {
    throw new TypeError("O argumento fornecido não é uma string");
  }

  // Converte a string para um objeto Date
  const date = new Date(dateStr);
  
  // Verifica se a conversão resultou em uma data válida
  if (isNaN(date)) {
    throw new TypeError("A string fornecida não é uma data válida");
  }

  const daysOfWeek = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() retorna um índice baseado em 0
  const year = date.getFullYear();
  const dayOfWeek = daysOfWeek[date.getDay()];

  return `${day}/${month}/${year} - ${dayOfWeek}`;
}
</script>

<div class="container">
  <Card shadow="sm" padding="sm">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="date-input" class="form-label">Selecione as datas:</label>
          <input
            id="date-input"
            type="text"
            class="form-control"
            readonly
            placeholder="Selecione as datas"
            on:click={() => (showModal = true)}
          />
        </div>
      </div>
    </div>
    <div
      class="selected-dates-container"
      style="max-height: 300px; overflow-y: auto;"
    >
      {#each selectedDates as date}
        <div class="input-group mb-3">
          <input type="text" class="form-control" readonly value={formatDateToBrazilian(date)} />
          <button
            class="btn btn-outline-secondary"
            type="button"
            on:click={() => removeDate(date)}
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      {/each}
    </div>
  </Card>
</div>

{#if showModal}
  <div
    class="modal d-block"
    tabindex="-1"
    aria-labelledby="calendarModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="calendarModalLabel">
            Selecione as datas
          </h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            on:click={() => (showModal = false)}
          ></button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <span class="arrow" on:click={() => changeMonth("prev")}>❮</span
                >
                <span>
                  {new Date(currentYear, currentMonth).toLocaleDateString(
                    "default",
                    {
                      month: "long",
                      year: "numeric",
                    },
                  )}
                </span>
                <span class="arrow" on:click={() => changeMonth("next")}>❯</span
                >
              </div>
            </div>
            <div class="card-body">
              <div class="days-of-week">
                {#each daysOfWeek as day}
                  <div>{day}</div>
                {/each}
              </div>
              <div class="calendar">
                {#each dates as date}
                  <div
                    class="day {classeSelecao[formatDate(date)]}"
                    on:click={() => {
                      date && toggleDate(date);
                      isDateSelected(date);
                    }}
                  >
                    {date ? date.getDate() : ""}
                  </div>
                {/each}
              </div>
              <button class="btn btn-secondary me-2" on:click={clearSelection}
                >Limpar</button
              >
              <button class="btn btn-primary" on:click={handleDateSelection}
                >Confirmar</button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal.d-block {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .calendar {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
  }

  .day {
    padding: 10px;
    text-align: center;
    cursor: pointer;
  }

  .selected {
    background-color: grey;
    color: white;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }

  .days-of-week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    text-align: center;
  }

  .arrow {
    cursor: pointer;
  }

  .selected-dates-container {
    margin-top: 10px;
  }

  .btn-outline-secondary {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fa-trash {
    pointer-events: none;
  }
</style>
